import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@features/auth/hooks/useAuth';
import { canAccessRoute, getDefaultRouteForRole } from '@lib/utils/roleNavigation';

export function RoleGuard() {
  const { user } = useAuth();
  const location = useLocation();

  if (!canAccessRoute(user?.role, location.pathname)) {
    return <Navigate to={getDefaultRouteForRole(user?.role)} replace />;
  }

  return <Outlet />;
}
